import { getPhotoUrl } from "../catalogApi";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";

export const TEMPLATE_LEGAL = {
  legalName: "Наименование",
  inn: "ИНН",
  contactFio: "ФИО контактного лица",
  workPhone: "Рабочий телефон",
  workEmail: "E-mail",
  share: "Доля",
  photoId: "Прикрепленные фото",
};
export const TEMPLATE_INDIVIDUAL = {
  fullName: "ФИО (полностью)",
  birthday: "Дата рождения",
  education: "Образование",
  jobExperience: "Опыт работы",
  share: "Доля",
  photoId: "Прикрепленные фото",
};

export const foundersHelper = (props: { [x: string]: string }) => {
  let founder = [];
  if (props.type === "Физическое лицо") {
    founder = Object.keys(TEMPLATE_INDIVIDUAL).map((item) => {
      return {
        label: TEMPLATE_INDIVIDUAL[item],
        value:
          item === "share"
            ? Number(props[item]).toFixed(2).toString() + "%"
            : item === "photoId"
            ? getPhotoUrl(props[item])
            : item === "birthday"
            ? props[item]
              ? dateFormat(props[item], { type: "date" })
              : ""
            : props[item],
      };
    });
  } else {
    founder = Object.keys(TEMPLATE_LEGAL).map((item) => {
      return {
        label: TEMPLATE_LEGAL[item],
        value:
          item === "share"
            ? Number(props[item]).toFixed(2).toString() + "%"
            : item === "photoId"
            ? getPhotoUrl(props[item])
            : props[item],
      };
    });
  }
  return founder;
};
